import { render, staticRenderFns } from "./WaybillGroupView.vue?vue&type=template&id=5bae895c&"
import script from "./WaybillGroupView.vue?vue&type=script&lang=js&"
export * from "./WaybillGroupView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports